<!--  -->
<template>
    <div class='content'>
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <!-- <el-breadcrumb-item>账单管理</el-breadcrumb-item> -->
                <el-breadcrumb-item style="font-size: 18px;font-weight: bold;">{{ language['日账单'][LT]
                }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="bill">
            <div class="screen">
                <div class="times">
                    <span> {{ language['选择时间'][LT]
                    }}</span>
                    <!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期时间"></el-date-picker> -->
                    <el-date-picker @change="getChangeTime" v-model="start_time" type="date"
                        :placeholder="language['选择日期时间'][LT]" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </div>

                <div class="btns">
                    <el-button type="danger" @click="getResetting"> {{ language['重置'][LT]
                    }}</el-button>
                    <el-button type="primary" @click="getScreen"> {{ language['筛选'][LT]
                    }}</el-button>
                </div>
            </div>
            <div class="order_info">
                <div class="order_num">
                    <img src="@/assets/img/12.png" alt="">
                    <div class="info">
                        <div class="info_title"> {{ language['日营业流水'][LT]
                        }}</div>
                        <div class="info_num">{{ allPrice }}</div>
                    </div>
                </div>
                <div class="order_num">
                    <img src="@/assets/img/11.png" alt="">
                    <div class="info">
                        <div class="info_title"> {{ language['日账单'][LT]
                        }}</div>
                        <div class="info_num">{{ orderNum }}</div>
                    </div>
                </div>
            </div>
            <div class="table">
                <el-table :empty-text="language['暂无数据'][LT]" :data="orderList" border style="width: 100%"
                    :header-cell-style="{ background: '#eee', }">
                    <el-table-column align="center" type="index" label="ID" width="100">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="order_sn" :label="language['订单编号'][LT]"
                        width="180"></el-table-column>
                    <el-table-column align="center" prop="table_id" :label="language['桌台号'][LT]"></el-table-column>
                    <el-table-column align="center" prop="person_num" :label="language['就餐人数'][LT]"></el-table-column>
                    <el-table-column align="center" prop="payable_money" :label="language['金额'][LT]"></el-table-column>
                    <el-table-column align="center" prop="real_money" :label="language['实际支付金额(元)'][LT]"></el-table-column>
                    <el-table-column align="center" prop="pay_type" :label="language['支付方式'][LT]"></el-table-column>
                    <el-table-column align="center" prop="create_time" :label="language['开始时间'][LT]"></el-table-column>
                    <el-table-column align="center" prop="pay_time" :label="language['结算时间'][LT]"></el-table-column>
                    <el-table-column align="center" prop="user_name" :label="language['大王炭火烤肉料理'][LT]"></el-table-column>
                    <el-table-column align="center" :label="language['操作'][LT]">
                        <template slot-scope="scope">
                            <el-button @click="getRouter(scope.row)" type="text" size="small"> {{ language['详情'][LT]
                            }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination @current-change="getChange" :current-page="page" background layout="prev, pager, next"
                    :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            value1: '',
            start_time: '', //选择时间
            orderList: [], //订单列表
            allPrice: 0,//流水
            orderNum: 0,//订单数
            total: 0, //数据总数
            allPage: 0, //总页数
            page: 1, //当前页数
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 账单列表
        getBillListMonth() {
            this.$post('64cc6460cf799', { type: 1, start_time: this.start_time, page: this.page }).then(res => {
                if (res.code == 1) {
                    console.log('日账单管理', res);
                    this.orderList = res.data.data;
                    this.orderNum = res.data.total_order;
                    this.allPrice = res.data.total_money;
                    this.total = res.data.total;
                    this.allPage = res.data.last_page;
                }
            })
        },
        // 切换分页
        getChange(event) {
            this.page = event;
            this.orderList = [];
            this.getBillListMonth();
        },
        // 时间选择
        getChangeTime(event) {
            console.log(event)
            this.start_time = event;
            this.cacheData()
        },
        // 时间筛选
        getScreen() {
            this.orderList = [];
            this.page = 1;
            this.getBillListMonth();
        },
        // 缓存
        cacheData(){
          sessionStorage.setItem('rnTime',this.start_time)
        },
        // 重置
        getResetting() {
            this.start_time = '';
            this.orderList = [];
            this.page = 1;
            this.cacheData()
            this.getBillListMonth();
        },
        getRouter(item) {
            this.$router.push({ path: '/orderDetail', query: { order_sn: item.order_sn } })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.start_time = sessionStorage.getItem('rnTime')
        this.getBillListMonth();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        console.log(this.$route.query);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.content {
    background: #eee;
    /* height: 100vh; */
    padding: 20px;
    box-sizing: border-box;
}

.crumbs {
    padding: 20px;
}

.bill {
    background: #fff;
    padding: 20px 10px;
}

.screen {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.times span {
    font-size: 14px;
    display: inline-block;
    width: 80px;
}

.btns {
    margin-left: 40px;
}

.order_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 500px;
    margin: 40px auto 10px;
}

.order_num {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.order_num img {
    width: 70px;
    height: 70px;
    margin-right: 10px;
}

.info_title {
    font-size: 16px;
    margin-bottom: 10px;
}

.info_num {
    font-size: 18px;
    color: red;
    font-weight: bold;
}

.table_num {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 40px;
}

.table_num span {
    display: inline-block;
    width: 50px;
    font-size: 14px;
}

.table {
    margin-top: 30px;
}

.page {
    text-align: center;
    margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/bill.vue